// /home/szymon/kreator2/frontend/src/components/MailSettingsPanel.js
// v2.1.0 – Bardziej szczegółowe logi w handleTestSend

import React, { useState, useEffect } from "react";

export default function MailSettingsPanel({ backendUrl }) {
  const [loading, setLoading] = useState(true);
  const [savingSettings, setSavingSettings] = useState(false);
  const [testSending, setTestSending] = useState(false);

  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [host, setHost] = useState("");
  const [port, setPort] = useState(587);
  const [secure, setSecure] = useState(false);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [fromName, setFromName] = useState("");

  const [testEmail, setTestEmail] = useState("");

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line
  }, []);

  const fetchSettings = () => {
    setLoading(true);
    fetch(`${backendUrl}/admin/mailsettings`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd pobierania ustawień mailowych.");
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (!data) return;
        setHost(data.host || "");
        setPort(data.port || 587);
        setSecure(data.secure || false);
        setUser(data.user || "");
        setPass(data.pass || "");
        setFromEmail(data.fromEmail || "");
        setFromName(data.fromName || "");
      })
      .catch((err) => {
        console.error("[MailSettingsPanel] fetchSettings =>", err);
        setLoading(false);
        setError("Nie udało się pobrać ustawień mailowych.");
      });
  };

  const handleSaveSettings = (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");
    setSavingSettings(true);

    const body = {
      host,
      port: Number(port),
      secure: Boolean(secure),
      user,
      pass,
      fromEmail,
      fromName
    };

    console.log("[MailSettingsPanel] handleSaveSettings => body =", body);

    fetch(`${backendUrl}/admin/mailsettings`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Błąd zapisu ustawień SMTP.");
        }
        return res.json();
      })
      .then((data) => {
        setSavingSettings(false);
        console.log("[MailSettingsPanel] Zapisano ustawienia =>", data);
        setSuccessMsg("Ustawienia zapisane poprawnie.");
      })
      .catch((err) => {
        console.error("[MailSettingsPanel] handleSaveSettings =>", err);
        setSavingSettings(false);
        setError("Nie udało się zapisać ustawień SMTP.");
      });
  };

  const handleTestSend = () => {
    setError("");
    setSuccessMsg("");
    setTestSending(true);

    if (!testEmail) {
      setError("Podaj adres e-mail do testu.");
      setTestSending(false);
      return;
    }

    console.log("[MailSettingsPanel] handleTestSend => toEmail =", testEmail);

    fetch(`${backendUrl}/admin/mailsettings/test`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ toEmail: testEmail })
    })
      .then((res) => {
        console.log("[MailSettingsPanel] /mailsettings/test => res status:", res.status);
        if (!res.ok) {
          throw new Error("Błąd podczas wysyłania testowego maila.");
        }
        return res.json();
      })
      .then((data) => {
        console.log("[MailSettingsPanel] testSend success =>", data);
        setTestSending(false);
        setSuccessMsg(`Wysłano testowy e-mail! messageId=${data.messageId || "?"}`);
      })
      .catch((err) => {
        console.error("[MailSettingsPanel] handleTestSend =>", err);
        setTestSending(false);
        setError("Nie udało się wysłać maila testowego.");
      });
  };

  if (loading) {
    return (
      <div className="orders-container">
        <p>Wczytywanie ustawień SMTP...</p>
      </div>
    );
  }

  return (
    <div className="orders-container" style={{ marginTop: 20 }}>
      <h3>Ustawienia Serwera SMTP</h3>
      {error && (
        <p className="dashboard-error" style={{ marginBottom: 8 }}>
          {error}
        </p>
      )}
      {successMsg && (
        <p style={{ color: "green", marginBottom: 8 }}>{successMsg}</p>
      )}

      {savingSettings && (
        <p style={{ marginBottom: 10, color: "#777" }}>
          Trwa zapisywanie ustawień... Proszę czekać.
        </p>
      )}

      <form onSubmit={handleSaveSettings} className="orders-add-form" style={{ maxWidth: 500 }}>
        <div className="orders-form-group">
          <label>Host:</label>
          <input
            type="text"
            value={host}
            onChange={(e) => setHost(e.target.value)}
            className="orders-input"
          />
        </div>
        <div className="orders-form-group">
          <label>Port:</label>
          <input
            type="number"
            value={port}
            onChange={(e) => setPort(e.target.value)}
            className="orders-input"
          />
        </div>
        <div className="orders-form-group">
          <label>Secure (TLS/SSL)?</label>
          <input
            type="checkbox"
            checked={secure}
            onChange={(e) => setSecure(e.target.checked)}
            style={{ marginLeft: 10 }}
          />
        </div>
        <div className="orders-form-group">
          <label>Użytkownik (login):</label>
          <input
            type="text"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            className="orders-input"
          />
        </div>
        <div className="orders-form-group">
          <label>Hasło:</label>
          <input
            type="password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            className="orders-input"
          />
        </div>
        <div className="orders-form-group">
          <label>Adres 'From':</label>
          <input
            type="email"
            value={fromEmail}
            onChange={(e) => setFromEmail(e.target.value)}
            className="orders-input"
          />
        </div>
        <div className="orders-form-group">
          <label>Nazwa 'From':</label>
          <input
            type="text"
            value={fromName}
            onChange={(e) => setFromName(e.target.value)}
            className="orders-input"
          />
        </div>

        <button
          type="submit"
          className="orders-button"
          style={{ marginTop: 10 }}
          disabled={savingSettings}
        >
          {savingSettings ? "Zapisywanie..." : "Zapisz"}
        </button>
      </form>

      <div style={{ marginTop: 30, padding: 10, border: "1px solid #ddd" }}>
        <h4>Wyślij testowy e-mail</h4>
        {testSending && (
          <p style={{ color: "#777", marginBottom: 10 }}>
            Trwa wysyłanie testowego maila, proszę czekać...
          </p>
        )}
        <div className="orders-form-group" style={{ maxWidth: 400 }}>
          <label>Adres docelowy:</label>
          <input
            type="email"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            className="orders-input"
            disabled={testSending}
          />
        </div>
        <button
          onClick={handleTestSend}
          className="orders-button"
          disabled={testSending}
        >
          {testSending ? "Wysyłanie..." : "Wyślij test"}
        </button>
      </div>
    </div>
  );
}
